"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var useHideSidebar_1 = __importDefault(require("../../../hooks/useHideSidebar"));
var loginState_1 = require("../../../types/loginState");
var Button_styles_1 = __importDefault(require("../../atoms/Button/Button.styles"));
var StyledFormPage_styles_1 = __importDefault(require("../../styled/StyledFormPage.styles"));
var Confirmed = function (_a) {
    var loggedIn = _a.loggedIn;
    useHideSidebar_1.default();
    if (loggedIn !== loginState_1.LOGGEDIN) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/login" });
    }
    return (react_1.default.createElement(StyledFormPage_styles_1.default, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement(StyledFormPage_styles_1.default, null,
                    react_1.default.createElement("div", { className: "header" },
                        react_1.default.createElement("h1", { className: "title" }, "Beschikbaarheid aangepast"),
                        react_1.default.createElement("p", { className: "description" }, "Je beschikbaarheid is succesvol aangepast en verwerkt.")))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/availability-overview" },
                    react_1.default.createElement(Button_styles_1.default, { className: "button secondary" },
                        react_1.default.createElement("span", null, "Naar het overzicht"),
                        react_1.default.createElement("svg", { className: "icon icon-arrow icon-right", "aria-hidden": "true" },
                            react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#arrow-right" }))))))));
};
exports.default = Confirmed;
